import './DifferentialAnalysis.css';
// Builds the UI entirely with JS and uses the CSS file above for styling.

//Code added by Malcolm as template for Differential Analysis page
const DifferentialAnalysis = () => {
  return (
    <div id="diff-app">
      <header className="header">
        <div className="title">Exploratory Analysis</div>
        <div className="header-center">
          <div className="pca" tabIndex="0" aria-haspopup="true">
            <div className="trigger">PCA</div>
            <div className="menu" role="menu" aria-label="PCA samples">
              <a href="#" role="menuitem" data-sample="1">Sample 1</a>
              <a href="#" role="menuitem" data-sample="2">Sample 2</a>
              <a href="#" role="menuitem" data-sample="3">Sample 3</a>
            </div>
          </div>
        </div>
        <div className="header-actions" role="toolbar">
          <button className="btn" id="applyBtn" type="button">Apply</button>
          <button className="btn primary" id="doneBtn" type="button">Done! Exploration</button>
        </div>  
      </header>
      <div className="body">
        
        <main className="content">
          <div className="exploration" id="exploration">
            {/* white canvas for exploration */}
          </div>
        </main>
      </div>
    </div>
  );
}
export default DifferentialAnalysis;

//Original Code Advaith wrote:
/*
// inject CSS so the generated HTML uses DifferentialAnalysis.css
const cssHref = './DifferentialAnalysis.css';
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = cssHref;
document.head.appendChild(link);

  // Close menu when clicking outside
  useEffect(() => {
    function handleDocClick(e) {
      if (pcaRef.current && !pcaRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleDocClick);
    return () => document.removeEventListener("mousedown", handleDocClick);
  }, []);

  // Select sample
  function handleSelectSample(s) {
    console.log("PCA sample selected", s);
    setPcaLabel(`PCA · Sample ${s}`);
    setMenuOpen(false);
    setTimeout(() => setPcaLabel("PCA"), 1200);
  }

  // Header actions
  function onApply() {
    console.log("Apply clicked");
  }
  function onDone() {
    console.log("Done Exploration clicked");
  }

  // Keyboard handling for PCA trigger/menu
  function onPcaKeyDown(e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setMenuOpen((v) => {
        const newV = !v;
        if (!v) {
          // open -> focus first menu item
          setTimeout(() => firstMenuItemRef.current?.focus(), 0);
        }
        return newV;
      });
    } else if (e.key === "Escape") {
      setMenuOpen(false);
      // return focus to trigger
      pcaRef.current?.querySelector(".trigger")?.focus();
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      if (!menuOpen) {
        setMenuOpen(true);
        setTimeout(() => firstMenuItemRef.current?.focus(), 0);
      } else {
        firstMenuItemRef.current?.focus();
      }
    }
  }

  return (
    <div id="diff-app">
      <header className="header" role="banner">
        <div className="title">Exploratory Analysis</div>

        <div className="header-center">
          <div
            className={`pca ${menuOpen ? "open" : ""}`}
            ref={pcaRef}
            tabIndex={0}
            aria-haspopup="true"
            aria-expanded={menuOpen}
            onKeyDown={onPcaKeyDown}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <div className="trigger" role="button" aria-label="PCA trigger">
              {pcaLabel}
            </div>

            <div
              className="menu"
              role="menu"
              aria-label="PCA samples"
              style={{ display: menuOpen ? "block" : "none" }}
            >
              <a
                href="#"
                role="menuitem"
                ref={firstMenuItemRef}
                onClick={(e) => {
                  e.preventDefault();
                  handleSelectSample(1);
                }}
              >
                Sample 1
              </a>
              <a
                href="#"
                role="menuitem"
                onClick={(e) => {
                  e.preventDefault();
                  handleSelectSample(2);
                }}
              >
                Sample 2
              </a>
              <a
                href="#"
                role="menuitem"
                onClick={(e) => {
                  e.preventDefault();
                  handleSelectSample(3);
                }}
              >
                Sample 3
              </a>
            </div>
          </div>
        </div>

        <div className="header-actions" role="toolbar" aria-label="Header actions">
          <button className="btn" id="applyBtn" type="button" onClick={onApply}>
            Apply
          </button>
          <button className="btn primary" id="doneBtn" type="button" onClick={onDone}>
            Done! Exploration
          </button>
        </div>
      </header>

      <div className="body">
        <nav className="left" aria-label="Side navigation">
          <a className="nav-item upload" href="#" aria-label="Data Upload">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M5 20h14v-2H5v2zm7-18l-7 7h4v6h6v-6h4l-7-7z" />
            </svg>
            <span>Data Upload</span>
          </a>

          <a className="nav-item analysis" href="#" aria-label="Analysis">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M3 17h3v4H3v-4zm5-8h3v12H8V9zm5-4h3v16h-3V5zm5 6h3v10h-3V11z" />
            </svg>
            <span>Analysis</span>
          </a>

          <a className="nav-item results" href="#" aria-label="Results">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M12 6a9.77 9.77 0 0 0-9 6 9.77 9.77 0 0 0 18 0 9.77 9.77 0 0 0-9-6zm0 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8z" />
            </svg>
            <span>Results</span>
          </a>
        </nav>

        <main className="content">
          <div className="exploration" id="exploration">
            {/* white canvas area — render your charts / UI here }
          </div>
        </main>
      </div>
    </div>
  `;
  header.appendChild(center);

  // header actions (buttons)
  const actions = document.createElement('div');
  actions.className = 'header-actions';
  actions.setAttribute('role','toolbar');
  actions.innerHTML = `
    <button class="btn" id="applyBtn" type="button">Apply</button>
    <button class="btn primary" id="doneBtn" type="button">Done! Exploration</button>
  `;
  header.appendChild(actions);

  // body
  const body = document.createElement('div');
  body.className = 'body';
  app.appendChild(body);

  // nav
  const nav = document.createElement('nav');
  nav.className = 'left';
  nav.setAttribute('aria-label','Side navigation');
  nav.innerHTML = `
    <a class="nav-item" href="#" aria-label="Data Upload">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 20h14v-2H5v2zm7-18l-7 7h4v6h6v-6h4l-7-7z"/></svg>
      <span>Data Upload</span>
    </a>
    <a class="nav-item" href="#" aria-label="Analysis">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 17h3v4H3v-4zm5-8h3v12H8V9zm5-4h3v16h-3V5zm5 6h3v10h-3V11z"/></svg>
      <span>Analysis</span>
    </a>
    <a class="nav-item" href="#" aria-label="Results">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 6a9.77 9.77 0 0 0-9 6 9.77 9.77 0 0 0 18 0 9.77 9.77 0 0 0-9-6zm0 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"/></svg>
      <span>Results</span>
    </a>
  `;
  body.appendChild(nav);

  // main content
  const main = document.createElement('main');
  main.className = 'content';
  main.innerHTML = `<div class="exploration" id="exploration"> <!-- white canvas --> </div>`;
  body.appendChild(main);

  // simple interactivity: menu clicks
  document.querySelectorAll('.pca .menu a').forEach(a=>{
    a.addEventListener('click', e=>{
      e.preventDefault();
      const s = e.currentTarget.dataset.sample;
      console.log('PCA sample selected', s);
      // basic feedback: highlight selection for 1s
      const trigger = document.querySelector('.pca .trigger');
      const old = trigger.textContent;
      trigger.textContent = `PCA · Sample ${s}`;
      setTimeout(()=> trigger.textContent = 'PCA', 1200);
    })
  });

  // buttons
  document.getElementById('applyBtn').addEventListener('click', ()=> console.log('Apply clicked'));
  document.getElementById('doneBtn').addEventListener('click', ()=> console.log('Done Exploration clicked'));

  // keyboard support: open menu with Enter when PCA focused
  const pca = document.querySelector('.pca');
  pca.addEventListener('keydown', e=>{
    if(e.key === 'Enter' || e.key === ' '){
      e.preventDefault();
      // toggle a class to show menu via CSS focus-within works; set focus to first menu item
      const first = pca.querySelector('.menu a');
      first && first.focus();
    }
  });

})();
*/

